import { isEmpty } from "lodash/fp";

import useProductivityIntegrationStatus from "@app/analytics/hooks/integrations/useProductivityIntegrationStatus";
import useForYouTeaser from "@app/analytics/MeetingReports/hooks/useForYouTeaser";
import Config from "@app/config";

import { Row } from "@rui/Stack";

import ForYouTeaser from "./ForYouTeaser";
import ReadoutStatus from "./ReadoutStatus/ReadoutStatus";

const ReportStatusesAndUpsells = () => {
  const integrationStatus = useProductivityIntegrationStatus();
  const forYouTeaser = useForYouTeaser();

  const fypTeaserVisible =
    forYouTeaser.shouldUpsell || Boolean(forYouTeaser.result);

  if (!fypTeaserVisible && isEmpty(integrationStatus.statuses)) return null;

  return (
    <Row spacing={2} justifyContent="space-evenly" pt={2}>
      {Config.flags.enableInitialReadoutExperience && (
        <ReadoutStatus
          additionalModules={fypTeaserVisible ? 1 : 0}
          {...integrationStatus}
        />
      )}
      <ForYouTeaser {...forYouTeaser} />
    </Row>
  );
};

export default ReportStatusesAndUpsells;
